var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "page-header" }, [
        _c("button", { staticClass: "add_role", on: { click: _vm.add } }, [
          _vm._v("新增角色"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "page-main" },
        [
          _c("a-table", {
            staticClass: "table_data",
            attrs: {
              pagination: _vm.pagination,
              columns: _vm.columns,
              dataSource: _vm.dataList,
              rowKey: "roleId",
              loading: _vm.loading,
            },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function (text, record) {
                  return _c("div", {}, [
                    _c(
                      "a",
                      {
                        staticStyle: {
                          "margin-right": "10px",
                          color: "#2a82e4",
                        },
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(record)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "a",
                      {
                        staticStyle: { color: "red" },
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(record)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.title,
            width: "750px",
            visible: _vm.visible,
            maskClosable: false,
            footer: "",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-form-model",
            _vm._b(
              {
                ref: "ruleForm",
                attrs: { model: _vm.formData, rules: _vm.rules },
              },
              "a-form-model",
              _vm.layout,
              false
            ),
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "角色名称" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入角色名称" },
                    model: {
                      value: _vm.formData.roleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "roleName", $$v)
                      },
                      expression: "formData.roleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "描述" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入描述" },
                    model: {
                      value: _vm.formData.roleDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "roleDesc", $$v)
                      },
                      expression: "formData.roleDesc",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "permissions_data" },
                [
                  _c("div", { staticClass: "permissions_data_header" }, [
                    _c("p", [_vm._v("权限设置")]),
                  ]),
                  _c("Role", {
                    ref: "mrole",
                    attrs: { "role-value": _vm.roleValue },
                    on: { "role-change": _vm.roleChange },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { "wrapper-col": { span: 14, offset: 4 } } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCancel("ruleForm")
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }